<template>
    <NuxtLayout>
        <div
            v-if="loading"
            class="fixed left-0 top-0 h-0.5 w-full z-50 bg-green-500"
        />
        <NuxtPage />
        <Toaster class="pointer-events-auto" />
    </NuxtLayout>
</template>

<script setup lang="ts">
import { Toaster } from "@/components/ui/sonner";
import "vue-sonner/style.css";

const nuxtApp = useNuxtApp();
const { t, te } = useI18n();

const loading = ref(false);

nuxtApp.hook("page:start", () => {
    loading.value = true;
});

nuxtApp.hook("page:finish", () => {
    loading.value = false;
});

useHead({
    titleTemplate: (pageTitle?: string) => {
        if (pageTitle && te(pageTitle)) {
            // Translate page titles that are i18n keys
            return `${t(pageTitle)} | ${t("core.title")}`;
        } else if (pageTitle) {
            // Use page titles that are plain strings as-is
            return `${pageTitle} | ${t("core.title")}`;
        } else {
            // Default title
            return t("core.title");
        }
    },
});
</script>
